module.exports = __webpack_public_path__ + "img/1.932d3ab1.jpg";